import { StatusDisplayProps } from "@/common/components/Status/StatusDisplay";
import { assertNever } from "@/common/ts/typeHelpers";
import {
  AvailabilityStatus,
  GeneralStatusIdentifier,
  OperabilityStatus,
  UtilizationStatus,
  VehicleStatus,
} from "@/core/api/generated/v1";

import { GeneralStatusEnumValueInlineProps } from "../GeneralStatusEnumValueInline";
import { AvailabilityStatusDisplay } from "./AvailabilityStatusDisplay";
import { OperabilityStatusDisplay } from "./OperabilityStatusDisplay";
import { UtilizationStatusDisplay } from "./UtilizationStatusDisplay";
import { VehicleStatusDisplay } from "./VehicleStatusDisplay";

interface Props {
  identifier: GeneralStatusIdentifier | null | undefined;
  value: string | null | undefined;
  statusProps?: Partial<StatusDisplayProps>;
  enumInlineProps?: Partial<GeneralStatusEnumValueInlineProps>;
}

export function GeneralStatusDisplay({ identifier, value, statusProps, enumInlineProps }: Props) {
  if (!identifier || !value) {
    return null;
  }

  switch (identifier) {
    case GeneralStatusIdentifier.None:
      return null;
    case GeneralStatusIdentifier.VehicleStatus:
      return (
        <VehicleStatusDisplay
          status={value as VehicleStatus}
          statusProps={statusProps}
          enumInlineProps={enumInlineProps}
        />
      );
    case GeneralStatusIdentifier.AvailabilityStatus:
      return (
        <AvailabilityStatusDisplay
          status={value as AvailabilityStatus}
          statusProps={statusProps}
          enumInlineProps={enumInlineProps}
        />
      );
    case GeneralStatusIdentifier.OperabilityStatus:
      return (
        <OperabilityStatusDisplay
          status={value as OperabilityStatus}
          statusProps={statusProps}
          enumInlineProps={enumInlineProps}
        />
      );
    case GeneralStatusIdentifier.UtilizationStatus:
      return (
        <UtilizationStatusDisplay
          status={value as UtilizationStatus}
          statusProps={statusProps}
          enumInlineProps={enumInlineProps}
        />
      );
    default:
      assertNever(identifier);
  }
}
